/**
 * Generated by orval 🍺
 * Do not edit manually.
 * Backoffice API Gateway
 * OpenAPI spec version: 1.0.0
 */
import type { RtsStatus } from "../model"

import { backofficeRequest } from "../../client"

type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1]

/**
 * @summary Check if an account has RTS (Radio Teleswitch) meters
 */
export const getAccountRtsStatus = (
  accountId: number,
  options?: SecondParameter<typeof backofficeRequest<RtsStatus>>,
) => {
  return backofficeRequest<RtsStatus>(
    { url: `/accounts/${accountId}/rts-status`, method: "GET" },
    options,
  )
}
export type GetAccountRtsStatusResult = NonNullable<
  Awaited<ReturnType<typeof getAccountRtsStatus>>
>
